module.exports = __webpack_public_path__ + "static/media/Carat-Down2.850b365e.svg";